import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Download, Infinity, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { scrollToPurchase } from '../utils/scrollToPurchase';
export function IncludesSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-106">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-b from-zinc-900 to-zinc-950 border border-zinc-800 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-107">
        {/* Decorative background element */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-108" />

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8 uppercase flex items-center gap-3" data-id="element-109">
          <span className="text-amber-500" data-id="element-110">🔥</span> INCLUYE
        </h2>

        <div className="space-y-6 mb-12" data-id="element-111">
          <div className="flex items-center gap-4 bg-zinc-800/50 p-4 rounded-xl border border-zinc-700/50" data-id="element-112">
            <div className="bg-amber-500 text-zinc-950 p-2 rounded-lg" data-id="element-113">
              <Check className="w-6 h-6" data-id="element-114" />
            </div>
            <span className="text-xl font-bold text-white" data-id="element-115">
              Plan principal paso a paso
            </span>
          </div>

          <div className="flex items-center gap-4 bg-zinc-800/30 p-4 rounded-xl border border-zinc-800" data-id="element-116">
            <div className="text-amber-500 text-2xl" data-id="element-117">🎁</div>
            <span className="text-lg text-zinc-300" data-id="element-118">
              Implementación en 14 días
            </span>
          </div>

          <div className="flex items-center gap-4 bg-zinc-800/30 p-4 rounded-xl border border-zinc-800" data-id="element-119">
            <div className="text-amber-500 text-2xl" data-id="element-120">🎁</div>
            <span className="text-lg text-zinc-300" data-id="element-121">
              Guía Anti-Finde (cómo no terminar destruido)
            </span>
          </div>

          <div className="flex items-center gap-4 bg-zinc-800/30 p-4 rounded-xl border border-zinc-800" data-id="element-122">
            <div className="text-amber-500 text-2xl" data-id="element-123">🎁</div>
            <span className="text-lg text-zinc-300" data-id="element-124">
              Protocolo Anticancelaciones
            </span>
          </div>
        </div>

        <div className="text-center border-t border-zinc-800 pt-8" data-id="element-125">
          <div className="text-4xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-126">
            💰 HOY: <span className="text-amber-400" data-id="element-127">$19.990 ARS</span>
            <span className="block text-lg text-zinc-500 font-sans font-normal mt-2" data-id="element-128">
              (pago único)
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm text-zinc-400" data-id="element-129">
            <div className="flex items-center gap-2" data-id="element-130">
              <Download className="w-4 h-4 text-amber-500" data-id="element-131" /> Descarga inmediata
            </div>
            <div className="flex items-center gap-2" data-id="element-132">
              <Infinity className="w-4 h-4 text-amber-500" data-id="element-133" /> Acceso de por vida
            </div>
            <div className="flex items-center gap-2" data-id="element-134">
              <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-135" /> Garantía 7 días
            </div>
          </div>

          <Button size="xl" fullWidth onClick={scrollToPurchase} data-id="element-136">
            ACCEDER AHORA
          </Button>
        </div>
      </motion.div>
    </section>;
}